<template>
    <div class="row justify-content-center" v-if="!setHide">
        <div class="col-md-8">
            <Loading v-if="showLoading" />
            <div class="card mb-3 pt-3">
                <form class="row m-0" v-on:submit.prevent="submit">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>نام فارسی سازمان</label>
                            <input type="text" class="form-control" v-model="company.companyNameFa">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>نام انگلیسی سازمان</label>
                            <input type="text" class="form-control ltr-input" v-model="company.companyNameEn">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>شناسه ملی</label>
                            <input type="tel" class="form-control ltr-input" v-mask="'###########'"
                                v-model="company.nationalId">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>شماره ثبت</label>
                            <input type="tel" class="form-control ltr-input" v-mask="'#######'"
                                v-model="company.registryNo">
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>نام مسئول</label>
                            <input type="text" class="form-control" v-model="company.agentFirstName">
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>نام خانوادگی مسئول</label>
                            <input type="text" class="form-control" v-model="company.agentLastName">
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>کد ملی مسئول</label>
                            <input type="tel" class="form-control ltr-input" v-mask="'##########'"
                                v-model="company.agentNationalNo">
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>شماره همراه مسئول</label>
                            <input type="tel" class="form-control ltr-input" v-mask="'####-#######'"
                                v-model="company.agentMobile">
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>ایمیل مسئول</label>
                            <input type="email" class="form-control ltr-input" v-model="company.agentEmail">
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>شماره تماس (همراه با کد شهر)</label>
                            <input type="tel" class="form-control ltr-input" v-mask="'###-########'"
                                v-model="company.phone">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>رمز عبور</label>
                            <input type="password" class="form-control ltr-input" v-model="company.password">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>تکرار رمز عبور</label>
                            <input type="password" class="form-control ltr-input" v-model="company.confirmPassword">
                        </div>
                    </div>
                    <div class="col-md-3" v-if="$store.state.role == 'admin'">
                        <div class="form-group">
                            <label>سوییچ صادرکننده</label>
                            <select class="form-control" v-model="company.provider">
                                <option value="" selected disabled>انتخاب کنید</option>
                                <option v-for="(provider,index) in providers" :key="index" :value="provider.id">{{
                                    provider.title }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-12" v-if="$store.state.role == 'admin'">
                        <label class="custom-switch mb-3">
                            <input type="checkbox" name="custom-switch-checkbox" class="custom-switch-input"
                                v-model="company.tourism">
                            <span class="custom-switch-indicator"></span>
                            <span class="custom-switch-description">سازمان از نوع گردشگری می باشد</span>
                        </label>
                    </div>
                    <div class="col-md-12" v-if="$store.state.role == 'admin'">
                        <label class="custom-switch mb-3">
                            <input type="checkbox" name="custom-switch-checkbox2" class="custom-switch-input"
                                v-model="company.createWallet">
                            <span class="custom-switch-indicator"></span>
                            <span class="custom-switch-description">ایجاد کیف پول برای سازمان</span>
                        </label>
                    </div>
                    <div class="col-md-6" v-if="company.createWallet">
                        <div class="form-group">
                            <label>شماره حساب</label>
                            <input type="tel" class="form-control ltr-input" v-mask="'####################'"
                                v-model="company.accountNumber">
                        </div>
                    </div>
                    <div class="col-md-6" v-if="company.createWallet">
                        <div class="form-group">
                            <label>شماره شبا</label>
                            <input type="tel" class="form-control ltr-input" v-mask="'IR########################'"
                                v-model="company.iBan">
                        </div>
                    </div>
                    <div class="col-md-12" v-if="$store.state.role == 'admin'">
                        <label class="custom-switch mb-3">
                            <input type="checkbox" name="custom-switch-checkbox3" class="custom-switch-input"
                                v-model="company.fidaConsumerAllow">
                            <span class="custom-switch-indicator"></span>
                            <span class="custom-switch-description"> آیا برای این سازمان دسترسی کد فیدا (اتباع خارجی ) وجود
                                داشته باشد ؟ </span>
                        </label>
                    </div>
                    <div class="col-md-12 mb-3">
                        <button class="btn btn-success">ایجاد سازمان</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'Organization',
    props: ['closed'],
    data() {
        return {
            showLoading: false,
            providers: [],
            company: {
                companyNameFa: '',
                companyNameEn: '',
                nationalId: '',
                registryNo: '',
                agentFirstName: '',
                agentLastName: '',
                agentNationalNo: '',
                agentMobile: '',
                agentEmail: '',
                phone: '',
                password: '',
                confirmPassword: '',
                provider: '',
                tourism: false,
                createWallet: false,
                accountNumber: '',
                iBan: '',
                fidaConsumerAllow: false
            },
            setHide: false
        }
    },
    methods: {
        getData() {

            this.$api.get('Organizations/Issuers').then(({ data }) => {
                if (data.status)
                    this.providers = data.result;
            })
        },
        submit() {
            this.showLoading = true;
            const postedData = {
                ...this.company,
                agentMobile: this.company.agentMobile.replace('-', ''),
                tourism: this.company.tourism,
                createWallet: this.company.createWallet,
                fidaConsumerAllow: this.company.fidaConsumerAllow,
                phone: this.company.phone.replace('-', ''),
                cardIssuerId: this.company.provider,
                
            };
            this.$api.post('Management/RegisterLegalCustomer', postedData).then(({ data }) => {
                if (data.status) {
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'سازمان با موفقیت ایجاد شد'
                    }).then(() => {
                        this.company = {
                            companyNameFa: '',
                            companyNameEn: '',
                            nationalId: '',
                            registryNo: '',
                            agentFirstName: '',
                            agentLastName: '',
                            agentNationalNo: '',
                            agentMobile: '',
                            agentEmail: '',
                            phone: '',
                            password: '',
                            createWallet: false,
                            fidaConsumerAllow: false,
                            confirmPassword: '',
                            accountNumber: '',
                            iban: ''
                        }
                        if (this.closed)
                            this.setHide = true;
                        else
                            this.$router.push({ name: 'organizations' });
                    });
                }
            }).finally(() => {
                this.showLoading = false;
            });
        }
    },
    created() {
        this.getData();
    }
}
</script>